<template>
  <div class="input-border" :class="{dark, multi}">
    <slot />
  </div>
</template>
<script lang="ts" setup>

defineProps<{
  dark?:boolean,
  multi?: boolean
}>();

</script>
<style lang="scss">

.input-border{
  display: grid;
  height: 40px;

  grid-template-columns: auto 1fr;
  &.multi {
    grid-template-columns: auto 1fr 1fr;
  }
  --border-color: var(--pidz-black);
  .pidz-icon {
    color: var(--pidz-white);
    background-color: var(--pidz-blue);
    height: 40px;
    width: 40px;
    padding: 6px;
    border-radius: 6px 0 0 6px;
    border: 1px solid var(--border-color);
    border-right: 0;
  }

  input {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;

    font-family: inherit;
    background-color: var(--pidz-white);
    border: 1px solid var(--border-color);
    color: var(--pidz-body-text);

    border-radius: 0;

    &:last-child {
      border-left: 0px;
      border-radius: 0 6px 6px 0;
    }
  }

  &.dark {
    --border-color: var(--pidz-white);
    .pidz-icon {
      background-color: var(--pidz-white);
      color: var(--pidz-blue);
    }
    input {
      -webkit-appearance: none;
      appearance: none;
      margin: 0;

      background-color: var(--pidz-blue);
      color: var(--pidz-white);
    }
  }

  select {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
